<div class="app-dialog anomaly-list-dialog">
  <div class="app-dialog__heading">
    <button mat-icon-button type="button" class="anomaly-list-dialog-close" aria-label="Close" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="app-dialog__heading-copy">
      <span class="app-dialog__eyebrow">Analysis</span>
      <div class="app-dialog__title-row">
        <div class="app-dialog__title-copy">
          <h2 mat-dialog-title class="app-dialog__title">Detected Anomalies</h2>
          <p>Review the records identified by the detection run.</p>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-content class="app-dialog__content anomaly-dialog-content">
    <div class="anomaly-summary">
      <div class="summary-item">
        <span class="summary-label">Total Anomalies:</span>
        <span class="summary-value">{{ anomalyCount }}</span>
      </div>
      <div class="summary-item" *ngIf="!data.isColumnLevel">
        <span class="summary-label">Total Records:</span>
        <span class="summary-value">{{ data.totalRecords }}</span>
      </div>
      <div class="summary-item" *ngIf="data.isColumnLevel">
        <span class="summary-label">Column:</span>
        <span class="summary-value">{{ data.columnName }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Detection Method:</span>
        <span class="summary-value">{{ data.methodFamily }}</span>
      </div>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="anomaly-table">
        <!-- Number Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <!-- Table-level: Row Index Column (legacy - just indices) -->
        <ng-container matColumnDef="rowIndex">
          <th mat-header-cell *matHeaderCellDef>Row Index</th>
          <td mat-cell *matCellDef="let element">{{ element }}</td>
        </ng-container>

        <!-- Table-level with full data: Index Column -->
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>Index</th>
          <td mat-cell *matCellDef="let element">{{ element.index ?? element }}</td>
        </ng-container>

        <!-- Dynamic data columns for table-level with full row data -->
        <ng-container *ngFor="let column of dataColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column] ?? 'N/A' }}</td>
        </ng-container>

        <!-- Column-level: Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td mat-cell *matCellDef="let element">{{ element.value }}</td>
        </ng-container>

        <!-- Anomaly Score Column -->
        <ng-container matColumnDef="anomalyScore">
          <th mat-header-cell *matHeaderCellDef>Anomaly Score</th>
          <td mat-cell *matCellDef="let element">
            {{ element.anomaly_score?.toFixed(6) || 'N/A' }}
          </td>
        </ng-container>

        <!-- Column-level: Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">{{ element.type || 'N/A' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="app-dialog__actions dialog-actions">
    <button mat-raised-button (click)="onClose()">
      Close
    </button>
    <button mat-raised-button color="primary" (click)="downloadAnomalies()">
      <mat-icon svgIcon="download-white"></mat-icon>
      Download CSV
    </button>
  </mat-dialog-actions>
</div>
